(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ReservationAmenityManage',
	};

	var form_id = 'reservationamenitymanage-';

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		var note_fields = [
			'amount_notes',
			'notes',
			'client_notes',
		];

		// if amenity is set to "Other" display the text input to specify which
		$('#' + form_id + 'reservation_component_amenity_type_id').on('change', function onChange(e)
		{
			var amenity = parseInt($(this).val());

			if (amenity === 10) { // Other
				$('#' + form_id + 'reservation_component_amenity_other_desc').val('');
				$('.other-amenity-desc').removeClass('hidden');
			} else {
				$('.other-amenity-desc').addClass('hidden');
			}
		});

		// if the "Amenity is Applied" checkbox is checked
		// set the date on the "Date Applied" field to the current date
		// if there is no date set for it
		$('#' + form_id + 'applied').on('change', function onChange(e)
		{
			var checked    = $(this).is(':checked');
			var date_field = $('#' + form_id + 'applied_date');

			if (checked) {
				$('.applied-date-field').removeClass('hidden');

				if (date_field.val() === '') {
					date_field.data('DateTimePicker').date(moment());
				}
			} else {
				$('.applied-date-field').addClass('hidden');
			}
		});

		// if the date applied is set, check the amenity is applied checkbox
		$('#' + form_id + 'applied_date').on('dp.change', function onChange(e)
		{
			var value = $(this).val();

			if (value) {
				$('#' + form_id + 'applied').prop('checked', true);
			}
		});

		// show character counts for notes fields
		$.each(note_fields, function eachNoteField(i, field) {
			Adzuki.CharacterCount('#' + form_id + field, {
				max  : 100,
				label: '.' + field + '-count',
			});
		});

		// create task
		$('.create-task').on('change', function toggleCreateTask(e)
		{
			$('.amenity-task').toggleClass('hidden');
		});

		// when the source is changed, show/hide the redemption stuff
		$('#reservationamenitymanage-source').on('change', function onChange(e) {
			let sources =['supplier', 'home_office', 'signature'];

			if (sources.indexOf($(this).val()) > -1 && $('#reservationamenitymanage-offer_id option').length > 1) {
				$('.amenity-offer').removeClass('hidden');
			} else {
				$('.amenity-offer').addClass('hidden');
			}
		});

		// when the redeem offer radio options are changed
		$('.redeem-offer').on('change', function toggleRedemptionFields(e) {
			if ($(this).val() === "1") {
				$('.amenity-offers-list').removeClass('hidden');
				$('.amenity-offers-info').removeClass('hidden');
				$('.amenity-offer-submitted-date').removeClass('hidden');
			} else {
				$('.amenity-offers-list').addClass('hidden');
				$('#reservationamenitymanage-offer_id').val('');

				$('.amenity-offers-link').addClass('hidden');
				$('.amenity-offer-submitted-date').addClass('hidden');
				$('.amenity-offers-info').addClass('hidden');

				$('#reservationamenitymanage-reservation_component_amenity_type_id').removeClass('disabled');
				$('#reservationamenitymanage-reservation_component_amenity_type_id').prop('disabled', false);
				$('#reservationamenitymanage-alt_amenity_id').val('');
			}
		});

		// when they select an offer, we need to see what the amenity type is and set the one on the form to match
		$('#reservationamenitymanage-offer_id').on('change', function onChange(e) {
			var offer_id = $(this).val();

			if (offer_id === '') {
				$('.amenity-offers-link').addClass('hidden');
				$('.details').data('offer-id', '');

				$('#reservationamenitymanage-reservation_component_amenity_type_id').removeClass('disabled');
				$('#reservationamenitymanage-reservation_component_amenity_type_id').prop('disabled', false);
				$('#reservationamenitymanage-offer_registration_submitted').prop('checked', false);
				$('#reservationamenitymanage-alt_amenity_id').val('');
				$('.amenity-offers-info').removeClass('hidden');
				$('.amenity-offer-submitted-date').addClass('hidden');
			} else {
				Adzuki.Ajax.get('/ReservationAmenities/offerAmenityType/' + offer_id)
				.then(function _adjustSelection(response) {
					if (response.amenity_type !== null) {
						$('#reservationamenitymanage-reservation_component_amenity_type_id').val(response.amenity_type);
						$('#reservationamenitymanage-reservation_component_amenity_type_id').addClass('disabled');
						$('#reservationamenitymanage-reservation_component_amenity_type_id').prop('disabled', true);

						$('#reservationamenitymanage-alt_amenity_id').val(response.amenity_type);
						$('.other-amenity-desc').addClass('hidden');
						$('#reservationamenitymanage-reservation_component_amenity_other_desc').val('');
						$('#reservationamenitymanage-offer_registration_submitted').prop('checked', true);
						$('.amenity-offers-info').addClass('hidden');
						$('.amenity-offer-submitted-date').removeClass('hidden');
						$('#reservationamenitymanage-offer_date_submitted').data("DateTimePicker").date(moment(new Date(), "YYYY-DD-MM"));
						toastr.success(
							null,
							'Amenity type updated based on offer',
							{
								positionClass  : 'toast-top-center',
								timeOut        : 3000,
								extendedTimeOut: 0,
							}
						);
					}
				});

				$('.amenity-offers-link').removeClass('hidden');
				$('.details').data('offer-id', offer_id);
			}
		});

		// if they check the box for the submission, show the date field
		$('#reservationamenitymanage-offer_registration_submitted').on('click', function onClick(e) {
			if ($(this).prop('checked') === true) {
				$('.amenity-offer-submitted-date').removeClass('hidden');
				// $('#reservationamenitymanage-offer_date_submitted').val('');
				$('.amenity-offers-info').addClass('hidden');


				if ($('#reservationamenitymanage-offer_date_submitted').val() === '') {
					$('#reservationamenitymanage-offer_date_submitted').data("DateTimePicker").date(moment(new Date(), "YYYY-DD-MM"));
				}
			} else {
				$('.amenity-offer-submitted-date').addClass('hidden');
				$('.amenity-offers-info').removeClass('hidden');
			}
		});
	};
}(jQuery, window.Adzuki || {}));
